function removeFalsyValues(obj) {
    Object.keys(obj).forEach(key => {
        if (obj[key] == null) delete obj[key];
    });
    return obj;
}

const paramsMapping = {
    brand: { android: 'brandname', ios: 'brandname' },
    category: { android: 'Category', ios: 'Category' },
    customerID: { android: 'customerid', ios: 'customerid' },
    platform: { android: null, ios: null },
    site: { android: null, ios: null },
    pageName: { android: 'pname', ios: 'pname' }
};

function changeAsPerParamsMapping(params, appOS) {
    const retNewParams = { ...params };
    const numArr = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j'];
    Object.keys(params).forEach(param => {
        if (paramsMapping[param]) {
            if (paramsMapping[param][appOS] !== null) {
                const newKey = paramsMapping[param][appOS];
                retNewParams[newKey] = params[param];
            }
            delete retNewParams[param];
        }
        if (param === 'mobile' || param === 'mobileNumber') {
            const phoneNo = window && window.atob(retNewParams[param]);
            let phoneStr = '';
            phoneNo.split('').forEach(num => {
                phoneStr += numArr[Number(num)];
            });
            retNewParams[param] = phoneStr;
        }
    });
    return retNewParams;
}

// The function for loggin event in ios / android webview
function logEvent(name, params) {
    if (!name) {
        return;
    }

    // const newParams = changeAsPerParamsMapping(params, 'android');

    if (window.AnalyticsWebInterface) {
        const newParams = changeAsPerParamsMapping(params, 'android');
        // Call Android interface
        window.AnalyticsWebInterface.logEvent(name, JSON.stringify(newParams));
    } else if (window.webkit
        && window.webkit.messageHandlers
        && window.webkit.messageHandlers.firebase) {
        const newParams = changeAsPerParamsMapping(params, 'ios');
        // Call iOS interface
        const message = {
            command: 'logEvent',
            name,
            parameters: newParams
        };
        window.webkit.messageHandlers.firebase.postMessage(message);
    } else {
        // No Android or iOS interface found
        // console.log('No native APIs found.', newParams);
        window.dataLayer.push(params);
    }
}

// 2nd param set true if you want to merge with DTM object
export function setWindowDtm(dtm, mergeWindowDtm = false) {
    if (typeof window !== 'undefined') {
        if (window.dataLayer) {
            let newDtm = {};
            if (mergeWindowDtm) {
                newDtm = { ...window.dtm, ...dtm };
            } else {
                newDtm = { ...window.persistDtm, ...dtm };
            }
            window.dtm = removeFalsyValues(newDtm);
            const { deviceType, site, loginStatus, customerID, email, mobile, mobileNumber, userType, lastPurchaseDate, platform } = newDtm;
            window.persistDtm = removeFalsyValues({ deviceType, site, loginStatus, customerID, email, mobile, mobileNumber, userType, lastPurchaseDate, platform });
            // window.dataLayer.push(newDtm);
            logEvent(newDtm && newDtm.event || 'generic', newDtm);
        } else {
            setTimeout(() => {
                setWindowDtm(dtm, mergeWindowDtm);
            }, 2010);
        }
    }
}

export function getDTMCategory(path) {
    let dtmCMSCategory = '';
    if (path.indexOf('premium-eyeglasses') > -1) {
        dtmCMSCategory = 'premium-eyeglasses';
    } else if (path.indexOf('premium-sunglasses') > -1) {
        dtmCMSCategory = 'premium-sunglasses';
    } else if (path.indexOf('eyeglasses.html') > -1) {
        dtmCMSCategory = 'eyeglasses';
    } else if (path.indexOf('sunglasses.html') > -1) {
        dtmCMSCategory = 'sunglasses';
    } else if (path.indexOf('contact-lenses.html') > -1) {
        dtmCMSCategory = 'contact-lenses';
    }
    return dtmCMSCategory;
}
